export const prices = {
  filters: {
    asPrice: function (value) {
      let price = Number.prototype.toFixed.call(parseFloat(value) || 0, 2)
      price = price.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
      return price + ' грн'
    },
    asPriceNoCurrency: function (value) {
      let price = Number.prototype.toFixed.call(parseFloat(value) || 0, 2)
      price = price.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
      return price
    }
  },
  methods: {
    formatPrice (amount) {
      if (!amount) {
        amount = 0
      }

      const c = amount.toLocaleString('uk-UK', {
        style: 'currency',
        currency: 'UAH',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })

      return c.replace('грн', '')
    }
  }
}
